import {AlarmActionsHeader} from "../utils/alarms-actions-ui.jsx";
import {useMemo} from "react";

const CeleparDataTable = ({data, name, className}) => {
  const occ = useMemo(() => {
    if (!data?.occurrences) return [];

    try {
      const parsedOccurrences = typeof data.occurrences === "string"
        ? JSON.parse(data.occurrences)
        : data.occurrences;

      return Array.isArray(parsedOccurrences) ? parsedOccurrences : [];
    } catch {
      return [];
    }
  }, [data])

  const odd = "border border-[#e7e7e7] text-black! text-start!"
  const even = "border border-[#e7e7e7] text-start!";

  return(
    <div className={[className, "w-full"].join(" ")}>
      <AlarmActionsHeader header={name}/>
      <div className="border border-[#505050] p-2">
        <table className=" border-collapse text-[#4f4f4f]!">
          <tbody>
            <tr className="bg-[#fafafa]">
              <th colSpan={1} className="border border-[#e7e7e7] text-start!">Modelo</th>
              <td colSpan={1} className="border border-[#e7e7e7] text-start!">{data?.model ?? ""}</td>
              <th colSpan={1} className="border border-[#e7e7e7] text-start!">Cor</th>
              <td colSpan={1} className="border border-[#e7e7e7] text-start!">{data?.color ?? ""}</td>
            </tr>
            { occ.length > 0 &&
              occ.map((item, idx) =>
                <tr key={idx} className={idx % 2 === 0 ? "" : "bg-[#fafafa]"}>
                  <th colSpan={1} className={idx % 2 === 0 ? even : odd}>{item?.dataRegistro ?? ""}</th>
                  <td colSpan={3} className={idx % 2 === 0 ? even : odd}>{item?.tipoOcorrencia ?? ""}</td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CeleparDataTable;
